import { useGridApiRef } from '@mui/x-data-grid-pro';
import type { ReportJobTypes } from '@vy/types';
import type { PartialNever } from '@vy/utils';
import { isNotNullOrUndefined, caseInsensitiveIncludes, isNullOrUndefined, vyDate } from '@vy/utils';
import React, { useMemo, useState } from 'react';
import { useReports } from '../../../../../hooks/requests/use-reports';
import { ReportJobsTable } from './report-jobs-table/ReportJobsTable';

export type ReportJobsDownloadProps = {
  asDownload?: boolean;
  onDownload?: (reportJobId: string) => Promise<void> | void;
};

type ReportJobsSectionProps = {
  reportJobType: ReportJobTypes;
  filter?: string;
} & (Required<ReportJobsDownloadProps> | PartialNever<ReportJobsDownloadProps>);

export const ReportJobsSection: React.FC<ReportJobsSectionProps> = ({
  reportJobType,
  filter,
  ...downloadProps
}) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const { data: reportsData, isLoading: isLoadingReports } = useReports();
  const tableRows = reportsData.filter(({ type }) => type === reportJobType);
  const filteredRows = useMemo(() => {
    const filtered = tableRows.filter(
      ({ reportName }) =>
        isNullOrUndefined(filter) ||
        (isNotNullOrUndefined(reportName) && caseInsensitiveIncludes(reportName, filter)),
    );

    return [...filtered].sort((firstReportJob, secondReportJob) => {
      return vyDate(secondReportJob.createdAt).valueOf() - vyDate(firstReportJob.createdAt).valueOf();
    });
  }, [tableRows, filter]);
  const apiRef = useGridApiRef();

  return (
    <ReportJobsTable
      {...downloadProps}
      itemsCount={filteredRows.length}
      loadingItems={isLoadingReports}
      items={filteredRows}
      paginationMode="client"
      apiRef={apiRef}
      showPagination
      hideFooter
      page={page}
      pageSize={pageSize}
      onPageChange={setPage}
      onPageSizeChange={setPageSize}
    />
  );
};
